import { default as COLORS } from './../../../../theme/colors';

const APP_COLORS = {
  lighterGrey: '#F0F0F0',
  lightGrey: '#CCCED0',
  paleGrey: '#B5BBC0',
  midGrey: '#838B93',
  deepGrey: '#687078',
  darkGrey: '#505558',
  charcoalGrey: '#2C3135',

  background: '#f7f7f7',
  pureWhite: '#ffffff',
  offWhite: '#Fbfdfe',

  offBlack: '#060400',

  primary: '#EA1B0A',
  secondary: '#EA1B0A',
  tertiary: '#CCCED0',

  negative: '#C41708',
  warning: '#FFC940',
  success: '#18A087',

  consumption: '#F59A86',
  production: '#7ACAFF',
  self_consumption: '#CA6FBA',

  total_battery: '#F05B48',
  self_consumption_battery: '#F05B48',
  soc_battery: '#C41708',
  production_to_battery: '#27A9FF',

  savings: '#B3ACA9',
  revenues: '#767676',
  cost_1: '#B3ACA9',
  cost_2: '#767676',

  from_shared: '#F3856D',
  to_shared: '#52BAFF',
  total_shared: '#DBA6D1',

  total_grid: '#F0D8EB',
  from_grid: '#F6C1B0',
  to_grid: '#A3DAFF',
};

export default {
  ...COLORS,
  ...APP_COLORS,
};
